import { inArray } from "../utils/helpers";

(function() {
  const filterLists = document.querySelectorAll(".filter-list");

  filterLists.forEach(filterList => {
    filterList.addEventListener("submit", event => {
      event.preventDefault();
      const filterDropdown = filterList.querySelector("select");
      const filterSelection =
        filterDropdown.options[filterDropdown.selectedIndex].value;
      const filterSelectionText =
        filterDropdown.options[filterDropdown.selectedIndex].text;
      const filterSection = filterList.querySelector(".filter-list__items");
      const filterItems = filterSection.querySelectorAll(".filter-list__item");

      const errors = filterList.querySelectorAll(".partner-resource-error");
      errors.forEach(error => {
        error.parentNode.removeChild(error);
      });

      // Sometimes the filter section is hidden when it should display.  Force
      // the section to display and let the logic below handle visibility.
      if (
        filterSelectionText === "All" ||
        filterSelectionText === "- Select -"
      ) {
        filterSection.classList.remove("jp-hidden");
        filterSection.setAttribute("aria-hidden", "false");
      }

      filterItems.forEach(filterItem => {
        const filters = filterItem.querySelectorAll("[data-filter]");
        let filterMatches = 0;

        filters.forEach(filter => {
          const filterData = filter.getAttribute("data-filter").split(", ");

          if (inArray(filterSelection, filterData)) {
            filterMatches += 1;
          }
        });

        // We only want to hide items which do not match the filter selection.
        // "All" is our empty option so it will not match anything.
        if (
          filterSelectionText !== "All" &&
          filterSelectionText !== "- Select -" &&
          filterSelectionText !== "- Select all -" &&
          filterMatches === 0
        ) {
          filterItem.closest(".filter-list__item").classList.add("jp-hidden");
          filterItem
            .closest(".filter-list__item")
            .setAttribute("aria-hidden", "true");
        } else {
          filterItem
            .closest(".filter-list__item")
            .classList.remove("jp-hidden");
          filterItem
            .closest(".filter-list__item")
            .setAttribute("aria-hidden", "false");
        }
      });

      const totalHiddenItems = filterSection.querySelectorAll(".jp-hidden");

      if (totalHiddenItems.length === filterItems.length) {
        filterSection.classList.add("jp-hidden");
        filterSection.setAttribute("aria-hidden", "true");
        const resourceError = document.createElement("p");
        resourceError.classList.add("partner-resource-error");
        resourceError.classList.add("margin-top-2");
        resourceError.innerHTML = `There are no results for <strong>${filterSelectionText}</strong>.`;
        filterList.querySelector(".grid-container").appendChild(resourceError);
      } else {
        filterSection.classList.remove("jp-hidden");
        filterSection.setAttribute("aria-hidden", "false");
      }
    });
  }, false);
})();
